import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import axios from 'axios';
import { connect } from 'react-redux';
import classNames from 'classnames';
import ScoringLoader, { endpointNames } from 'general/js/loaders/scoring-loader';
import { makeCancelable } from 'general/js/helpers';
import { BlockSpinner } from 'components/block-spinner';
import { BlockPlaceholder } from 'components/block-placeholder';
import { LiveTextListing } from 'components/live-text';

class LiveWidgetVideos extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            batches: [],
            nextBatchId: null,
            type: null,
            isFetching: false,
            showSpinner: true
        };
    }

    componentDidMount() {
        this.getData();
        this.getDataAfterTimeout();
        ScoringLoader.subscribe(endpointNames.LIVE_SCANNER);
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId);
        this.cancelGetData();
        ScoringLoader.subscribe(endpointNames.LIVE_SCANNER);
    }

    onLoadMore = () => {
        this.getData(true);
    }

    getTopBatchId() {
        const topBatch = this.state.batches[0];

        return (topBatch && topBatch.id) || null;
    }

    getUpdatedBatches(newBatches) {
        const { batches } = this.state;
        const topBatchId = this.getTopBatchId();
        const hasTopBatch = newBatches.some((newBatch) => newBatch.id === topBatchId);

        if (!hasTopBatch) {
            return newBatches;
        }

        for (let i = newBatches.length - 1; i >= 0; i--) {
            const newBatch = newBatches[i];
            const foundBatch = batches.find((batch) =>
                batch.id === newBatch.id);

            if (foundBatch) {
                if (foundBatch.lastUpdated !== newBatch.lastUpdated) {
                    foundBatch.posts = newBatch.posts;
                    foundBatch.lastUpdated = newBatch.lastUpdated;
                }
            } else {
                batches.unshift(newBatch);
            }
        }

        return batches;
    }

    getDataAfterTimeout() {
        const updateInSeconds = this.props.options.updateInSeconds || 20;

        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
            this.setState({
                showSpinner: false,
            }, this.getData);
        }, updateInSeconds * 1000);
    }

    getData(isLoadMore) {
        const { context } = this.props.options;
        const { nextBatchId, type } = this.state;
        const qsProps = { context };
        let url = this.props.options.endpointUrl;

        if (isLoadMore) {
            url += '/' + nextBatchId;
        }

        if (type) {
            qsProps.type = type;
        }

        url += '?' + qs.stringify(qsProps);

        this.cancelGetData();
        this.cancelableGetData = makeCancelable(axios.get(url));
        this.cancelableGetData
            .promise
            .then((response) => {
                if (!response.data || !Array.isArray(response.data.batches)) {
                    return;
                }

                let batches = [];

                if (isLoadMore) {
                    batches = this.state.batches;
                    batches.push(...response.data.batches);
                } else {
                    batches = this.getUpdatedBatches(response.data.batches);
                }

                this.setState({
                    batches,
                    nextBatchId: response.data.nextBatch || null,
                    isFetching: false,
                });
                this.getDataAfterTimeout();
            })
            .catch((error) => {
                if (!error.isCanceled) {
                    this.setState({ isFetching: false, showSpinner: true });
                    this.getDataAfterTimeout();
                }
            });

        this.setState({ isFetching: true });
    }

    cancelGetData() {
        if (this.cancelableGetData) {
            this.cancelableGetData.cancel();
        }
    }

    getPosts() {
        const { batches } = this.state;
        const posts = [];

        batches.forEach((batch) => {
            if (Array.isArray(batch.posts)) {
                posts.push(...batch.posts);
            }
        });

        return posts;
    }

    render() {
        const { isFetching, nextBatchId } = this.state;
        const { options, liveScanner } = this.props;
        const posts = this.getPosts();

        const showLoadMore = nextBatchId && posts.length < options.maxPosts;
        const loadMoreCss = classNames({
            'is-loading': isFetching
        });

        if (!liveScanner) { return null; }

        return (
            liveScanner.liveComponents.liveText.show ?
                <BlockPlaceholder minHeight={300}>
                    {isFetching && <BlockSpinner hasOverlay />}
                    <LiveTextListing posts={posts} targetsConfig={options.targetsConfig} patronLogo={options.patronLogo} />
                    {
                        showLoadMore &&
                        <div className={`listing-load-more spinner ${loadMoreCss}`}>
                            <button
                                className="listing-load-more__button button button--primary"
                                type="button"
                                onClick={this.onLoadMore}
                            >load more
                        </button>
                        </div>
                    }                  
                </BlockPlaceholder>
                :
                <div className="live-widget__holding-message">
                    {liveScanner.liveComponents.liveText.subtitle}
                </div>
        );
    }
}

const mapStateToProps = (state) => ({
    liveScanner: state.scoring[endpointNames.LIVE_SCANNER],
});

LiveWidgetVideos.propTypes = {
    options: PropTypes.object,
    mediaContentType: PropTypes.string
};

const LiveWidgetPostsWrapper = connect(
    mapStateToProps,
    null
)(LiveWidgetVideos);

export default LiveWidgetPostsWrapper;
